import { getProfileList, getProfileNetInfo, getProfileRadioInfo, getProfileVapInfo, deleteProfile, saveNetwork, saveRadio, saveVap } from './profile-data';
import { addAccountApply, getAccountApplyList, confirmAccountApply, deleteAccount, getAccountDetail, addAccount, editAccount , postAccountOperationStatus , getAccountOperationStatusList} from './account-data';
import { removeRole, getRoleDetail, addRole, editRole } from './role-data';
import { getNotifySettings, saveNotifySettings, testSMTPEmail } from './notification-data';
import { getNetworkSettings, saveNetworkSettings } from './network-data';
import { saveNetworkZone, removeNetworkZone } from './network-zone-data';
import { saveInitailSetup } from './initial-data';
import { getPrismXSysInfo, localSoftwareUpdate, saveSystemDate } from '../../actions/settings/about-data';
// import { triggerDeviceInfo } from '../../actions/device/device-data';
import { Netmask } from 'netmask';
import { convertBandwidth, saveGlobalApSettings, deleteWiFiSettingsData, getGroupDevice, saveWiFiSettingsData, syncWifiSetting, deleteGuestPortalSettingsData, deleteGroupAPSettingsData, saveApExlusionData } from './wifi-data';
import { triggerApConfig } from '../../actions/device/device-configuration';

// Settings page
export const WAIT_INIT_SETTINGS = "WAIT_INIT_SETTINGS";

// Profile
export const SELECT_SETTING_PROFILE = "SELECT_SETTING_PROFILE";
export const GET_SETTING_PROFILE_LIST = "GET_SETTING_PROFILE_LIST";
export const GET_SETTING_PROFILE_LIST_SUCCESS = "GET_SETTING_PROFILE_LIST_SUCCESS";
export const GET_SETTING_PROFILE_LIST_FAIL = "GET_SETTING_PROFILE_LIST_FAIL";
export const DELETE_SETTING_PROFILE = "DELETE_SETTING_PROFILE";
export const DELETE_SETTING_PROFILE_SUCCESS = "DELETE_SETTING_PROFILE_SUCCESS";
export const DELETE_SETTING_PROFILE_FAIL = "DELETE_SETTING_PROFILE_FAIL";
export const GET_SETTING_PROFILE_NET = "GET_SETTING_PROFILE_NET";
export const GET_SETTING_PROFILE_NET_SUCCESS = "GET_SETTING_PROFILE_NET_SUCCESS";
export const GET_SETTING_PROFILE_NET_FAIL = "GET_SETTING_PROFILE_NET_FAIL";
export const SAVE_SETTING_PROFILE_NET = "SAVE_SETTING_PROFILE_NET";
export const SAVE_SETTING_PROFILE_NET_SUCCESS = "SAVE_SETTING_PROFILE_NET_SUCCESS";
export const SAVE_SETTING_PROFILE_NET_FAIL = "SAVE_SETTING_PROFILE_NET_FAIL";
export const GET_SETTING_PROFILE_RADIO = "GET_SETTING_PROFILE_RADIO";
export const GET_SETTING_PROFILE_RADIO_SUCCESS = "GET_SETTING_PROFILE_RADIO_SUCCESS";
export const GET_SETTING_PROFILE_RADIO_FAIL = "GET_SETTING_PROFILE_RADIO_FAIL";
export const SAVE_SETTING_PROFILE_RADIO = "SAVE_SETTING_PROFILE_RADIO";
export const SAVE_SETTING_PROFILE_RADIO_SUCCESS = "SAVE_SETTING_PROFILE_RADIO_SUCCESS";
export const SAVE_SETTING_PROFILE_RADIO_FAIL = "SAVE_SETTING_PROFILE_RADIO_FAIL";
export const GET_SETTING_PROFILE_VAP = "GET_SETTING_PROFILE_VAP";
export const GET_SETTING_PROFILE_VAP_SUCCESS = "GET_SETTING_PROFILE_VAP_SUCCESS";
export const GET_SETTING_PROFILE_VAP_FAIL = "GET_SETTING_PROFILE_VAP_FAIL";
export const SAVE_SETTING_PROFILE_VAP = "SAVE_SETTING_PROFILE_VAP";
export const SAVE_SETTING_PROFILE_VAP_SUCCESS = "SAVE_SETTING_PROFILE_VAP_SUCCESS";
export const SAVE_SETTING_PROFILE_VAP_FAIL = "SAVE_SETTING_PROFILE_VAP_FAIL";

// Account
export const SAVE_SETTING_ACCOUNT_APPLY = "SAVE_SETTING_ACCOUNT_APPLY";
export const SAVE_SETTING_ACCOUNT_APPLY_SUCCESS = "SAVE_SETTING_ACCOUNT_APPLY_SUCCESS";
export const SAVE_SETTING_ACCOUNT_APPLY_FAIL = "SAVE_SETTING_ACCOUNT_APPLY_FAIL";
export const GET_SETTING_ACCOUNT_APPLY_LIST = "GET_SETTING_ACCOUNT_APPLY_LIST";
export const GET_SETTING_ACCOUNT_APPLY_LIST_SUCCESS = "GET_SETTING_ACCOUNT_APPLY_LIST_SUCCESS";
export const GET_SETTING_ACCOUNT_APPLY_LIST_FAIL = "GET_SETTING_ACCOUNT_APPLY_LIST_FAIL";
export const CONFIRM_SETTING_ACCOUNT_APPLY = "CONFIRM_SETTING_ACCOUNT_APPLY";
export const CONFIRM_SETTING_ACCOUNT_APPLY_SUCCESS = "CONFIRM_SETTING_ACCOUNT_APPLY_SUCCESS";
export const CONFIRM_SETTING_ACCOUNT_APPLY_FAIL = "CONFIRM_SETTING_ACCOUNT_APPLY_FAIL";
export const SELECT_SETTING_ACCOUNT = "SELECT_SETTING_ACCOUNT";
export const DELETE_SETTING_ACCOUNT = "DELETE_SETTING_ACCOUNT";
export const DELETE_SETTING_ACCOUNT_SUCCESS = "DELETE_SETTING_ACCOUNT_SUCCESS";
export const DELETE_SETTING_ACCOUNT_FAIL = "DELETE_SETTING_ACCOUNT_FAIL";
export const GET_SETTING_ACCOUNT_DETAIL = "GET_SETTING_ACCOUNT_DETAIL";
export const GET_SETTING_ACCOUNT_DETAIL_FAIL = "GET_SETTING_ACCOUNT_DETAIL_FAIL";
export const GET_SETTING_ACCOUNT_DETAIL_SUCCESS = "GET_SETTING_ACCOUNT_DETAIL_SUCCESS";
export const SAVE_SETTING_ACCOUNT_DETAIL = "SAVE_SETTING_ACCOUNT_DETAIL";
export const SAVE_SETTING_ACCOUNT_DETAIL_FAIL = "SAVE_SETTING_ACCOUNT_DETAIL_FAIL";
export const SAVE_SETTING_ACCOUNT_DETAIL_SUCCESS = "SAVE_SETTING_ACCOUNT_DETAIL_SUCCESS";
export const LOAD_SETTING_ACCOUNT_LIST = "LOAD_SETTING_ACCOUNT_LIST";
export const LOAD_SETTING_FLOOR_PLAN_LIST = "LOAD_SETTING_FLOOR_PLAN_LIST";

// Account Opereation Status
export const GET_ACCOUNT_OPERATION_STATUS_SUCCESS = "GET_ACCOUNT_OPERATION_STATUS_SUCCESS";
export const SAVE_ACCOUNT_OPERATION_STATUS_IN_FRONT_END = "SAVE_ACCOUNT_OPERATION_STATUS_IN_FRONT_END";

// Role
export const SELECT_SETTING_ROLE = "SELECT_SETTING_ROLE";
export const DELETE_SETTING_ROLE = "DELETE_SETTING_ROLE";
export const DELETE_SETTING_ROLE_SUCCESS = "DELETE_SETTING_ROLE_SUCCESS";
export const DELETE_SETTING_ROLE_FAIL = "DELETE_SETTING_ROLE_FAIL";
export const GET_SETTING_ROLE_DETAIL = "GET_SETTING_ROLE_DETAIL";
export const GET_SETTING_ROLE_DETAIL_FAIL = "GET_SETTING_ROLE_DETAIL_FAIL";
export const GET_SETTING_ROLE_DETAIL_SUCCESS = "GET_SETTING_ROLE_DETAIL_SUCCESS";
export const SAVE_SETTING_ROLE_DETAIL = "SAVE_SETTING_ROLE_DETAIL";
export const SAVE_SETTING_ROLE_DETAIL_FAIL = "SAVE_SETTING_ROLE_DETAIL_FAIL";
export const SAVE_SETTING_ROLE_DETAIL_SUCCESS = "SAVE_SETTING_ROLE_DETAIL_SUCCESS";

// Notification
export const GET_NOTIFICATION_SETTING = "GET_NOTIFICATION_SETTING";
export const GET_NOTIFICATION_SETTING_SUCCESS = "GET_NOTIFICATION_SETTING_SUCCESS";
export const GET_NOTIFICATION_SETTING_FAIL = "GET_NOTIFICATION_SETTING_FAIL";
export const SAVE_NOTIFICATION_SETTING = "SAVE_NOTIFICATION_SETTING";
export const SAVE_NOTIFICATION_SETTING_SUCCESS = "SAVE_NOTIFICATION_SETTING_SUCCESS";
export const SAVE_NOTIFICATION_SETTING_FAIL = "SAVE_NOTIFICATION_SETTING_FAIL";
export const TEST_SMTP_EMAIL = "TEST_SMTP_EMAIL";
export const TEST_SMTP_EMAIL_SUCCESS = "TEST_SMTP_EMAIL_SUCCESS";
export const TEST_SMTP_EMAIL_FAIL = "TEST_SMTP_EMAIL_FAIL";

// Network
export const GET_NETWORK_SETTING = "GET_NETWORK_SETTING";
export const GET_NETWORK_SETTING_SUCCESS = "GET_NETWORK_SETTING_SUCCESS";
export const GET_NETWORK_SETTING_FAIL = "GET_NETWORK_SETTING_FAIL";
export const SAVE_NETWORK_SETTING = "SAVE_NETWORK_SETTING";
export const SAVE_NETWORK_SETTING_SUCCESS = "SAVE_NETWORK_SETTING_SUCCESS";
export const SAVE_NETWORK_SETTING_FAIL = "SAVE_NETWORK_SETTING_FAIL";

// Initial Setup
export const SAVE_INITIAL_SETUP = "SAVE_INITIAL_SETUP";
export const SAVE_INITIAL_SETUP_SUCCESS = "SAVE_INITIAL_SETUP_SUCCESS";
export const SAVE_INITIAL_SETUP_FAIL = "SAVE_INITIAL_SETUP_FAIL";

// about setting
export const GET_SETTING_ABOUT_SUCCESS = "GET_SETTING_ABOUT_SUCCESS";
export const GET_SETTING_ABOUT_FAIL = "GET_SETTING_ABOUT_FAIL";
export const PRISMX_LOCAL_UPGRADE_SUCCESS = "PRISMX_LOCAL_UPGRADE_SUCCESS";
export const PRISMX_LOCAL_UPGRADE_FAIL = "PRISMX_LOCAL_UPGRADE_FAIL";
export const PRISMX_LOCAL_UPGRADE_INIT = "PRISMX_LOCAL_UPGRADE_INIT";
export const SAVE_SYSTEM_DATE = "SAVE_SYSTEM_DATE";
export const SAVE_SYSTEM_DATE_SUCCESS = "SAVE_SYSTEM_DATE_SUCCESS";
export const SAVE_SYSTEM_DATE_FAIL = "SAVE_SYSTEM_DATE_FAIL";

// ================== wifi setting ==================
// site radio setting
export const GET_GLOBAL_AP_SETTING = "GET_GLOBAL_AP_SETTING";
export const GET_GLOBAL_AP_SETTING_SUCCESS = "GET_GLOBAL_AP_SETTING_SUCCESS";
export const GET_GLOBAL_AP_SETTING_FAIL = "GET_GLOBAL_AP_SETTING_FAIL";
export const SAVE_GLOBAL_AP_SETTING = "SAVE_GLOBAL_AP_SETTING";
export const SAVE_GLOBAL_AP_SETTING_SUCCESS = "SAVE_GLOBAL_AP_SETTING_SUCCESS";
export const SAVE_GLOBAL_AP_SETTING_FAIL = "SAVE_GLOBAL_AP_SETTING_FAIL";
export const GET_GROUP_DEVICES = "GET_GROUP_DEVICES";
export const GET_GROUP_DEVICES_SUCCESS = "GET_GROUP_DEVICES_SUCCESS";
export const GET_GROUP_DEVICES_FAIL = "GET_GROUP_DEVICES_FAIL";
export const GET_GROUP_AP_SETTINGS_DETAIL_SUCCESS = "GET_GROUP_AP_SETTINGS_DETAIL_SUCCESS";
export const DELETE_GROUP_AP_SETTINGS_DATA = "DELETE_GROUP_AP_SETTINGS_DATA";
export const DELETE_GROUP_AP_SETTINGS_DATA_SUCCESS = "DELETE_GROUP_AP_SETTINGS_DATA_SUCCESS";
export const DELETE_GROUP_AP_SETTINGS_DATA_FAIL = "DELETE_GROUP_AP_SETTINGS_DATA_FAIL";

// network zone setting
export const SELECT_NETWORK_ZONE_DETAIL = "SELECT_NETWORK_ZONE_DETAIL";
export const SAVE_NETWORK_ZONE_DATA = "SAVE_NETWORK_ZONE_DATA";
export const SAVE_NETWORK_ZONE_DATA_SUCCESS = "SAVE_NETWORK_ZONE_DATA_SUCCESS";
export const SAVE_NETWORK_ZONE_DATA_FAIL = "SAVE_NETWORK_ZONE_DATA_FAIL";
export const SAVE_NETWORK_ZONE_IMPORT_FILE_FAIL = "SAVE_NETWORK_ZONE_IMPORT_FILE_FAIL";
export const DELETE_NETWORK_ZONE = "DELETE_NETWORK_ZONE";
export const DELETE_NETWORK_ZONE_SUCCESS = "DELETE_NETWORK_ZONE_SUCCESS";
export const DELETE_NETWORK_ZONE_FAIL = "DELETE_NETWORK_ZONE_FAIL";

// wifi setting
export const GET_WIFI_SETTINGS_DETAIL_SUCCESS = "GET_WIFI_SETTINGS_DETAIL_SUCCESS";
export const GET_WIFI_SETTINGS_DETAIL_FAIL = "GET_WIFI_SETTINGS_DETAIL_FAIL";
export const SAVE_WIFI_SETTINGS_DETAIL_DATA = "SAVE_WIFI_SETTINGS_DETAIL_DATA";
export const DELETE_WIFI_SETTINGS_SUCCESS = "DELETE_WIFI_SETTINGS_SUCCESS";
export const DELETE_WIFI_SETTINGS_FAIL = "DELETE_WIFI_SETTINGS_FAIL";
export const DELETE_WIFI_SETTINGS = "DELETE_WIFI_SETTINGS";
export const SET_WIFI_LIST = "SET_WIFI_LIST";

// sync device 
export const SYNC_WIFI_SETTING = "SYNC_WIFI_SETTING";
export const SYNC_WIFI_SETTING_SUCCESS = "SYNC_WIFI_SETTING_SUCCESS";
export const SYNC_WIFI_SETTING_FAIL = "SYNC_WIFI_SETTING_FAIL";
export const SAVE_WIFI_SETTINGS_DATA = "SAVE_WIFI_SETTINGS_DATA";
export const SAVE_WIFI_SETTINGS_DATA_SUCCESS = "SAVE_WIFI_SETTINGS_DATA_SUCCESS";
export const SAVE_WIFI_SETTINGS_DATA_FAIL = "SAVE_WIFI_SETTINGS_DATA_FAIL";


// AP Exclusions

export const GET_AP_EXCLUSION_SETTINGS_DETAIL_SUCCESS = "GET_AP_EXCLUSION_SETTINGS_DETAIL_SUCCESS";
export const SAVE_AP_EXCLUSION_DATA = "SAVE_AP_EXCLUSION_DATA";
export const SAVE_AP_EXCLUSION_DATA_SUCCESS = "SAVE_AP_EXCLUSION_DATA_SUCCESS";
export const SAVE_AP_EXCLUSION_DATA_FAIL = "SAVE_AP_EXCLUSION_DATA_FAIL";

// ================== wifi setting End ==================

// Guest Portal setting
export const GET_GUEST_PORTAL_SETTINGS_DETAIL_SUCCESS = "GET_GUEST_PORTAL_SETTINGS_DETAIL_SUCCESS";
export const DELETE_GUEST_PORTAL_SETTINGS = "DELETE_GUEST_PORTAL_SETTINGS";
export const DELETE_GUEST_PORTAL_SETTINGS_SUCCESS = "DELETE_GUEST_PORTAL_SETTINGS_SUCCESS";
export const DELETE_GUEST_PORTAL_SETTINGS_FAIL = "DELETE_GUEST_PORTAL_SETTINGS_FAIL";


export const doGetProfileList = (token, siteId) => (dispatch) => {
    let doPost = new Promise((resolve, reject) => {
        getProfileList(resolve, reject, token, siteId);
    });

    doPost
    .then((data) => {
        if ('success' === data.responseMsg) {
            dispatch({
                type: GET_SETTING_PROFILE_LIST_SUCCESS,
                params: {
                    profileList: data.data
                }
            });
        } else {
            dispatch({
                type: GET_SETTING_PROFILE_LIST_FAIL,
                params: {
                    errMsg: data.responseMsg
                }
            });
        }
    }).catch((err) => {
        dispatch({
            type: GET_SETTING_PROFILE_LIST_FAIL,
            params: {
                errMsg: err
            }
        });
    });

    dispatch({
        type: GET_SETTING_PROFILE_LIST
    });
}

export const doSelectProfile = (rowData) => (dispatch) => {
    dispatch({
        type: SELECT_SETTING_PROFILE,
        params: {
            selectProfile: rowData
        }
    });
}

export const doDeleteProfile = (token, profileId, site) => (dispatch) => {
    let doPost = new Promise((resolve, reject) => {
        deleteProfile(resolve, reject, token, profileId, site);
    });

    doPost
    .then((data) => {
        if ('success' === data.responseMsg) {
            if (data.isRemoveSuccess) {
                dispatch({
                    type: DELETE_SETTING_PROFILE_SUCCESS
                });
            } else {
                dispatch({
                    type: DELETE_SETTING_PROFILE_FAIL,
                    params: {
                        errMsg: 'Not found this profile.'
                    }
                });
            }            
        } else {
            dispatch({
                type: DELETE_SETTING_PROFILE_FAIL,
                params: {
                    errMsg: data.responseMsg
                }
            });
        }
    }).catch((err) => {
        dispatch({
            type: DELETE_SETTING_PROFILE_FAIL,
            params: {
                errMsg: err
            }
        });
    });

    dispatch({
        type: DELETE_SETTING_PROFILE
    });
}

export const doGetProfileNetInfo = (token, profileId) => (dispatch) => {
    let doPost = new Promise((resolve, reject) => {
        getProfileNetInfo(resolve, reject, token, profileId);
    });

    doPost
    .then((data) => {
        if ('success' === data.responseMsg) {
            dispatch({
                type: GET_SETTING_PROFILE_NET_SUCCESS,
                params: {                    
                    profileNetList: data.profileNetList
                }
            });
        } else {
            dispatch({
                type: GET_SETTING_PROFILE_NET_FAIL,
                params: {
                    errMsg: data.responseMsg
                }
            });
        }
    }).catch((err) => {
        dispatch({
            type: GET_SETTING_PROFILE_NET_FAIL,
            params: {
                errMsg: err
            }
        });
    });

    dispatch({
        type: GET_SETTING_PROFILE_NET
    });
}

export const doGetProfileRadioInfo = (token, profileId) => (dispatch) => {
    let doPost = new Promise((resolve, reject) => {
        getProfileRadioInfo(resolve, reject, token, profileId);
    });

    doPost
    .then((data) => {
        if ('success' === data.responseMsg) {
            dispatch({
                type: GET_SETTING_PROFILE_RADIO_SUCCESS,
                params: {
                    profileRadioList: data.profileRadioList
                }
            });
        } else {
            dispatch({
                type: GET_SETTING_PROFILE_RADIO_FAIL,
                params: {
                    errMsg: data.responseMsg
                }
            });
        }
    }).catch((err) => {
        dispatch({
            type: GET_SETTING_PROFILE_RADIO_FAIL,
            params: {
                errMsg: err
            }
        });
    });

    dispatch({
        type: GET_SETTING_PROFILE_RADIO
    });
}

export const doGetProfileVapInfo = (token, profileId) => (dispatch) => {
    let doPost = new Promise((resolve, reject) => {
        getProfileVapInfo(resolve, reject, token, profileId);
    });

    doPost
    .then((data) => {
        if ('success' === data.responseMsg) {
            dispatch({
                type: GET_SETTING_PROFILE_VAP_SUCCESS,
                params: {
                    profileVapList: data.profileVapList
                }
            });
        } else {
            dispatch({
                type: GET_SETTING_PROFILE_VAP_FAIL,
                params: {
                    errMsg: data.responseMsg
                }
            });
        }
    }).catch((err) => {
        dispatch({
            type: GET_SETTING_PROFILE_VAP_FAIL,
            params: {
                errMsg: err
            }
        });
    });

    dispatch({
        type: GET_SETTING_PROFILE_VAP
    });
}

export const doSaveNetwork = (token, reqBodyObj) => (dispatch) => {
    if (reqBodyObj) {
        let doPost = new Promise((resolve, reject) => {
            saveNetwork(resolve, reject, token, reqBodyObj);
        });
    
        doPost
        .then((data) => {
            if ('success' === data.responseMsg) {
                dispatch({
                    type: SAVE_SETTING_PROFILE_NET_SUCCESS,
                    params: {
                        saveProfileId: data.profileId
                    }
                });
            } else {
                dispatch({
                    type: SAVE_SETTING_PROFILE_NET_FAIL,
                    params: {
                        errMsg: data.responseMsg
                    }
                });
            }
        }).catch((err) => {
            dispatch({
                type: SAVE_SETTING_PROFILE_NET_FAIL,
                params: {
                    errMsg: err
                }
            });
        });
    }

    dispatch({
        type: SAVE_SETTING_PROFILE_NET        
    });
}

export const doSaveRadio = (token, reqBodyObj) => (dispatch) => {
    if (reqBodyObj) {
        let doPost = new Promise((resolve, reject) => {
            saveRadio(resolve, reject, token, reqBodyObj);
        });
    
        doPost
        .then((data) => {
            if ('success' === data.responseMsg) {
                dispatch({
                    type: SAVE_SETTING_PROFILE_RADIO_SUCCESS,
                    params: {
                        saveProfileId: data.profileId
                    }
                });
            } else {
                dispatch({
                    type: SAVE_SETTING_PROFILE_RADIO_FAIL,
                    params: {
                        errMsg: data.responseMsg
                    }
                });
            }
        }).catch((err) => {
            dispatch({
                type: SAVE_SETTING_PROFILE_RADIO_FAIL,
                params: {
                    errMsg: err
                }
            });
        });
    }

    dispatch({
        type: SAVE_SETTING_PROFILE_RADIO        
    });
}

export const doSaveVap = (token, reqBodyObj) => (dispatch) => {
    if (reqBodyObj) {
        let doPost = new Promise((resolve, reject) => {
            saveVap(resolve, reject, token, reqBodyObj);
        });
    
        doPost
        .then((data) => {
            if ('success' === data.responseMsg) {
                dispatch({
                    type: SAVE_SETTING_PROFILE_VAP_SUCCESS,
                    params: {
                        saveProfileId: data.profileId
                    }
                });
            } else {
                dispatch({
                    type: SAVE_SETTING_PROFILE_VAP_FAIL,
                    params: {
                        errMsg: data.responseMsg
                    }
                });
            }
        }).catch((err) => {
            dispatch({
                type: SAVE_SETTING_PROFILE_VAP_FAIL,
                params: {
                    errMsg: err
                }
            });
        });
    }

    dispatch({
        type: SAVE_SETTING_PROFILE_VAP        
    });
}

/*****************************
 *** Account & Role Page
 *****************************/

export const doAddAccountApply = (reqBodyObj) => (dispatch) => {
    if (reqBodyObj) {
        let doPost = new Promise((resolve, reject) => {
            addAccountApply(resolve, reject, reqBodyObj);
        });
    
        doPost
        .then((data) => {
            if ('success' === data.responseMsg) {
                dispatch({
                    type: SAVE_SETTING_ACCOUNT_APPLY_SUCCESS
                });
            } else {
                dispatch({
                    type: SAVE_SETTING_ACCOUNT_APPLY_FAIL,
                    params: {
                        errMsg: data.responseMsg ?? data.errMsg
                    }
                });
            }
        }).catch((err) => {
            dispatch({
                type: SAVE_SETTING_ACCOUNT_APPLY_FAIL,
                params: {
                    errMsg: err
                }
            });
        });
    }

    dispatch({
        type: SAVE_SETTING_ACCOUNT_APPLY        
    });
}

export const doGetAccountApplyList = (token) => (dispatch) => {
    let doPost = new Promise((resolve, reject) => {
        getAccountApplyList(resolve, reject, token);
    });

    doPost
    .then((data) => {
        if ('success' === data.responseMsg) {
            dispatch({
                type: GET_SETTING_ACCOUNT_APPLY_LIST_SUCCESS,
                params: {
                    accountApplyList: data.accountApplyList
                }
            });
        } else {
            dispatch({
                type: GET_SETTING_ACCOUNT_APPLY_LIST_FAIL,
                params: {
                    errMsg: data.responseMsg
                }
            });
        }
    }).catch((err) => {
        dispatch({
            type: GET_SETTING_ACCOUNT_APPLY_LIST_FAIL,
            params: {
                errMsg: err
            }
        });
    });

    dispatch({
        type: GET_SETTING_ACCOUNT_APPLY_LIST
    });
}

export const doConfirmAccountApply = (token, reqBodyObj) => (dispatch) => {
    if (reqBodyObj) {
        let doPost = new Promise((resolve, reject) => {
            confirmAccountApply(resolve, reject, token, reqBodyObj);
        });
    
        doPost
        .then((data) => {
            if ('success' === data.responseMsg) {
                dispatch({
                    type: CONFIRM_SETTING_ACCOUNT_APPLY_SUCCESS
                });
            } else {
                dispatch({
                    type: CONFIRM_SETTING_ACCOUNT_APPLY_FAIL,
                    params: {
                        errMsg: data.responseMsg
                    }
                });
            }
        }).catch((err) => {
            dispatch({
                type: CONFIRM_SETTING_ACCOUNT_APPLY_FAIL,
                params: {
                    errMsg: err
                }
            });
        });
    }

    dispatch({
        type: CONFIRM_SETTING_ACCOUNT_APPLY        
    });
}

export const doSelectAccount = (rowData) => (dispatch) => {
    dispatch({
        type: SELECT_SETTING_ACCOUNT,
        params: {
            selectAccount: rowData
        }
    });
}

export const doDeleteAccount = (token, accountSeq) => (dispatch) => {
    let doPost = new Promise((resolve, reject) => {
        deleteAccount(resolve, reject, token, accountSeq);
    });

    doPost
    .then((data) => {
        if ('success' === data.responseMsg) {
            dispatch({
                type: DELETE_SETTING_ACCOUNT_SUCCESS
            });
        } else {
            dispatch({
                type: DELETE_SETTING_ACCOUNT_FAIL,
                params: {
                    errMsg: data.responseMsg
                }
            });
        }
    }).catch((err) => {
        dispatch({
            type: DELETE_SETTING_ACCOUNT_FAIL,
            params: {
                errMsg: err
            }
        });
    });

    dispatch({
        type: DELETE_SETTING_ACCOUNT
    });
}

export const doGetAccountDetail = (token, accountSeq) => (dispatch) => {
    let doPost = new Promise((resolve, reject) => {
        getAccountDetail(resolve, reject, token, accountSeq);
    });

    doPost
    .then((data) => {
        if ('success' === data.responseMsg) {
            dispatch({
                type: GET_SETTING_ACCOUNT_DETAIL_SUCCESS,
                params: {
                    accountDetail: data.accountDetail
                }
            });
        } else {
            dispatch({
                type: GET_SETTING_ACCOUNT_DETAIL_FAIL,
                params: {
                    errMsg: data.responseMsg
                }
            });
        }
    }).catch((err) => {
        dispatch({
            type: GET_SETTING_ACCOUNT_DETAIL_FAIL,
            params: {
                errMsg: err
            }
        });
    });

    dispatch({
        type: GET_SETTING_ACCOUNT_DETAIL
    });
}

export const doSaveAccountDetail = (token, type, reqBodyObj, isSelf) => (dispatch) => {
    if (reqBodyObj) {
        let doPost = new Promise((resolve, reject) => {
            if (type === 'edit') {
                editAccount(resolve, reject, token, reqBodyObj);
            } else {
                addAccount(resolve, reject, token, reqBodyObj);
            }
        });
    
        doPost
        .then((data) => {
            if ('success' === data.responseMsg) {
                if(isSelf){
                    const loginParams = JSON.parse(window.sessionStorage.getItem(window.CONFIG.PROJECT_ID + window.CONFIG.WEB_CACHE_KEY.LOGIN));
                    loginParams.accountInfo.name = reqBodyObj.name;
                    loginParams.accountInfo.email = reqBodyObj.email;
                    window.sessionStorage.setItem(window.CONFIG.PROJECT_ID + window.CONFIG.WEB_CACHE_KEY.LOGIN, JSON.stringify(loginParams));
                }
                dispatch({
                    type: SAVE_SETTING_ACCOUNT_DETAIL_SUCCESS
                });
            } else {
                dispatch({
                    type: SAVE_SETTING_ACCOUNT_DETAIL_FAIL,
                    params: {
                        errMsg: data.responseMsg
                    }
                });
            }
        }).catch((err) => {
            dispatch({
                type: SAVE_SETTING_ACCOUNT_DETAIL_FAIL,
                params: {
                    errMsg: err
                }
            });
        });
    }

    dispatch({
        type: SAVE_SETTING_ACCOUNT_DETAIL        
    });
}

export const loadAccountSettingList = (accountData) => (dispatch) => {
    dispatch({
        type: LOAD_SETTING_ACCOUNT_LIST,
        params: {
            accountData: accountData
        }
    });
}

export const loadFloorPlanSettingList = (floorPlanData) => (dispatch) => {
    dispatch({
        type: LOAD_SETTING_FLOOR_PLAN_LIST,
        params: {
            floorPlanData: floorPlanData
        }
    });
}

export const doGetAccountOperationStatusList = (token) => (dispatch) => {
    let doPost = new Promise((resolve, reject) => {
        getAccountOperationStatusList(resolve, reject, token);
    });

    doPost
    .then((data) =>  {
        if ('success' === data.responseMsg){

            // data.accountOperationStatusList is string
            window.sessionStorage.setItem(window.CONFIG.PROJECT_ID + window.CONFIG.WEB_CACHE_KEY.ACCOUNT_OPERATION_STATUS, data.accountOperationStatusList)
            dispatch(
                {
                    type : GET_ACCOUNT_OPERATION_STATUS_SUCCESS,
                    params: {
                        accountOperationStatusList: JSON.parse(data.accountOperationStatusList)
                    }
                })

        } else{
            window.alert("Get Account Operation Status List failed");
        }
    }).catch((err) =>
    {
        window.alert("Get Account Operation Status List failed (error)");
        console.log("Get Account Operation Status List failed (error)")

    }

    )
}

export const doGetAccountOperationStatusListBySessionStorage = () => (dispatch) => {
    dispatch({
            type : GET_ACCOUNT_OPERATION_STATUS_SUCCESS,
            params: {
                accountOperationStatusList:  JSON.parse(window.sessionStorage.getItem(window.CONFIG.PROJECT_ID + window.CONFIG.WEB_CACHE_KEY.ACCOUNT_OPERATION_STATUS))
            }
        })
}


export const saveAccountOperationStatus = (token,tableId ,accountOperationStatus) => (dispatch) => {
    let doPost = new Promise((resolve, reject) => {
        postAccountOperationStatus(resolve, reject, token, {tableId: tableId , jsonStatus : JSON.stringify(accountOperationStatus) });
    });
    doPost
    .then((data) =>  {
        if ('success' === data.responseMsg){
            console.log( "Save Account Operation Status List Success");
        } else{
            window.alert("Save Account Operation Status List failed");

        }
    }).catch((err) =>
        window.alert("Save Account Operation Status List failed")
    )



}

export const saveAccountOperationStatusInFrontEnd = (accountOperationStatusList) => (dispatch) => {
    dispatch({
        type: SAVE_ACCOUNT_OPERATION_STATUS_IN_FRONT_END ,
        params: {
            accountOperationStatusList: accountOperationStatusList
        }
    });
}


export const doSelectRole = (rowData) => (dispatch) => {
    dispatch({
        type: SELECT_SETTING_ROLE,
        params: {
            selectRole: rowData
        }
    });
}

export const doRemoveRole = (token, seq) => (dispatch) => {
    let doPost = new Promise((resolve, reject) => {
        removeRole(resolve, reject, token, seq);
    });

    doPost
    .then((data) => {
        if ('success' === data.responseMsg) {
            dispatch({
                type: DELETE_SETTING_ROLE_SUCCESS
            });
        } else {
            dispatch({
                type: DELETE_SETTING_ROLE_FAIL,
                params: {
                    errMsg: data.responseMsg
                }
            });
        }
    }).catch((err) => {
        dispatch({
            type: DELETE_SETTING_ROLE_FAIL,
            params: {
                errMsg: err
            }
        });
    });

    dispatch({
        type: DELETE_SETTING_ROLE        
    });
}

export const doGetRoleDetail = (token, roleSeq) => (dispatch) => {
    let doPost = new Promise((resolve, reject) => {
        getRoleDetail(resolve, reject, token, roleSeq);
    });

    doPost
    .then((data) => {
        if ('success' === data.responseMsg) {
            let roleDetail = data.role ? data.role : {};
            roleDetail.auth = data.auth;
            roleDetail.groupList = data.groupList;

            dispatch({
                type: GET_SETTING_ROLE_DETAIL_SUCCESS,
                params: {
                    roleDetail: roleDetail
                }
            });
        } else {
            dispatch({
                type: GET_SETTING_ROLE_DETAIL_FAIL,
                params: {
                    errMsg: data.responseMsg
                }
            });
        }
    }).catch((err) => {
        dispatch({
            type: GET_SETTING_ROLE_DETAIL_FAIL,
            params: {
                errMsg: err
            }
        });
    });

    dispatch({
        type: GET_SETTING_ROLE_DETAIL
    });
}

export const doSaveRoleDetail = (token, type, reqBodyObj) => (dispatch) => {
    if (reqBodyObj) {
        let doPost = new Promise((resolve, reject) => {
            if (type === 'edit') {                
                editRole(resolve, reject, token, reqBodyObj);
            } else {
                addRole(resolve, reject, token, reqBodyObj);
            }
        });
    
        doPost
        .then((data) => {
            if ('success' === data.responseMsg) {
                dispatch({
                    type: SAVE_SETTING_ROLE_DETAIL_SUCCESS
                });
            } else {
                dispatch({
                    type: SAVE_SETTING_ROLE_DETAIL_FAIL,
                    params: {
                        errMsg: data.responseMsg
                    }
                });
            }
        }).catch((err) => {            
            dispatch({
                type: SAVE_SETTING_ROLE_DETAIL_FAIL,
                params: {
                    errMsg: err
                }
            });
        });
    }

    dispatch({
        type: SAVE_SETTING_ROLE_DETAIL        
    });
}

export const doGetNotifySettings = (token, site) => (dispatch) => {
    let doPost = new Promise((resolve, reject) => {
        getNotifySettings(resolve, reject, token, site);
    });

    doPost
    .then((data) => {
        if ('success' === data.responseMsg) {
            dispatch({
                type: GET_NOTIFICATION_SETTING_SUCCESS,
                params: {
                    notifyDetail: data.notifySetting
                }
            });
        } else {
            dispatch({
                type: GET_NOTIFICATION_SETTING_FAIL,
                params: {
                    errMsg: data.responseMsg
                }
            });
        }
    }).catch((err) => {
        dispatch({
            type: GET_NOTIFICATION_SETTING_FAIL,
            params: {
                errMsg: err
            }
        });
    });

    dispatch({
        type: GET_NOTIFICATION_SETTING
    });
}

export const doSaveNotifySettings = (token, site, notifyObj) => (dispatch) => {
    let doPost = new Promise((resolve, reject) => {
        saveNotifySettings(resolve, reject, token, site, notifyObj);
    });

    doPost
    .then((data) => {
        if ('success' === data.responseMsg) {
            dispatch({
                type: SAVE_NOTIFICATION_SETTING_SUCCESS,
            });
        } else {
            dispatch({
                type: SAVE_NOTIFICATION_SETTING_FAIL,
                params: {
                    errMsg: data.responseMsg
                }
            });
        }
    }).catch((err) => {
        dispatch({
            type: SAVE_NOTIFICATION_SETTING_FAIL,
            params: {
                errMsg: err
            }
        });
    });

    dispatch({
        type: SAVE_NOTIFICATION_SETTING
    });
}

export const doGetNetworkSettings = (token, site) => (dispatch) => {
    let doPost = new Promise((resolve, reject) => {
        getNetworkSettings(resolve, reject, token, site);
    });

    doPost
    .then((data) => {
        if ('success' === data.responseMsg) {
            let networkSettingObj = data.networkSetting;

            if (networkSettingObj && Object.keys(networkSettingObj).length !== 0 && Object.getPrototypeOf(networkSettingObj) === Object.prototype) {
                if (networkSettingObj.connType === "static") {
                    let netmask = new Netmask(networkSettingObj.ipAddress, networkSettingObj.subnetMask);
                    networkSettingObj.cidrFormat = networkSettingObj.ipAddress + "/" + netmask.bitmask;
                }
            }
            dispatch({
                type: GET_NETWORK_SETTING_SUCCESS,
                params: {
                    networkDetail: networkSettingObj
                }
            });
        } else {
            dispatch({
                type: GET_NETWORK_SETTING_FAIL,
                params: {
                    errMsg: data.responseMsg
                }
            });
        }
    }).catch((err) => {
        dispatch({
            type: GET_NETWORK_SETTING_FAIL,
            params: {
                errMsg: err
            }
        });
    });

    dispatch({
        type: GET_NETWORK_SETTING
    });
}

export const doSavNetworkSettings = (token, site, networkObj) => (dispatch) => {
    let doPost = new Promise((resolve, reject) => {
        saveNetworkSettings(resolve, reject, token, site, networkObj);
    });

    doPost
    .then((data) => {
        if ('success' === data.responseMsg) {
            dispatch({
                type: SAVE_NETWORK_SETTING_SUCCESS,
            });
        } else {
            dispatch({
                type: SAVE_NETWORK_SETTING_FAIL,
                params: {
                    errMsg: data.responseMsg
                }
            });
        }
    }).catch((err) => {
        dispatch({
            type: SAVE_NETWORK_SETTING_FAIL,
            params: {
                errMsg: err
            }
        });
    });

    dispatch({
        type: SAVE_NETWORK_SETTING
    });
}

export const doSaveInitailSetup = (token, data) => (dispatch) => {
    let doPost = new Promise((resolve, reject) => {
        saveInitailSetup(resolve, reject, token, data);
    });

    doPost
    .then((data) => {
        if ('success' === data.responseMsg) {
            dispatch({
                type: SAVE_INITIAL_SETUP_SUCCESS,
            });
        } else {
            dispatch({
                type: SAVE_INITIAL_SETUP_FAIL,
                params: {
                    errMsg: data.responseMsg
                }
            });
        }
    }).catch((err) => {
        dispatch({
            type: SAVE_INITIAL_SETUP_FAIL,
            params: {
                errMsg: err
            }
        });
    });

    dispatch({
        type: SAVE_INITIAL_SETUP
    });
}

export const doTestSMTPEmail = (token, account, notifyObj) => (dispatch) => {
    let doPost = new Promise((resolve, reject) => {
        testSMTPEmail(resolve, reject, token, account, notifyObj);
    });

    doPost
    .then((data) => {
        if('success' === data.responseMsg) {
            dispatch({
                type: TEST_SMTP_EMAIL_SUCCESS,
            });
        } else {
            dispatch({
                type: TEST_SMTP_EMAIL_FAIL,
                params: {
                    errMsg: data.responseMsg
                }
            });
        }
    }).catch((err) => {
        dispatch({
            type: TEST_SMTP_EMAIL_FAIL,
            params: {
                errMsg: err
            }
        });
    });

    dispatch({
        type: TEST_SMTP_EMAIL
    });
}

export const doGetAboutSettings = (token) => (dispatch) => {
    let doPost = new Promise((resolve, reject) => {
      getPrismXSysInfo(resolve, reject, token);
    })
    doPost.then((res)=> {
        if(res.responseMsg === 'success') {
            dispatch({
                type: GET_SETTING_ABOUT_SUCCESS,
                params: {
                    systemInfo: res.systemInfo,
                    mx100Time: res.mx100Time
                }
            });
        }
        else {
            dispatch({
                type: GET_SETTING_ABOUT_FAIL,
                params: {
                    errMsg: res.responseMsg
                }
            })
        }
    })
}


export const doSaveSystemDate = (token, date) => (dispatch) => {
    let doPost = new Promise((resolve, reject) => {
      saveSystemDate(resolve, reject, token, date);
    })
    doPost.then((res)=> {
        if(res.responseMsg === 'success') {
            dispatch({
                type: SAVE_SYSTEM_DATE_SUCCESS
            });
        }
        else {
            dispatch({
                type: SAVE_SYSTEM_DATE_FAIL
            })
        }
    })
    dispatch({
        type: SAVE_SYSTEM_DATE
    })
}






export const doSaveGlobalApSettings = (token, settingsObj) => (dispatch) => {
    triggerApConfig(token, null, settingsObj.site)
    .then((result)=> {
        if ('success' === result) {
            let value = convertBandwidth(settingsObj, true);
            let doPost = new Promise((resolve, reject) => {
                saveGlobalApSettings(resolve, reject, token, value);
            })
            doPost
            .then((data) => {
                if ('success' === data.responseMsg) {
                    let value = convertBandwidth(data.globalApSetting, false);
                    dispatch({
                        type: SAVE_GLOBAL_AP_SETTING_SUCCESS,
                        params: {
                            globalApInfo: value
                        }
                    });
                } else {
                    dispatch({
                        type: SAVE_GLOBAL_AP_SETTING_FAIL,
                        params: {
                            errMsg: data.responseMsg
                        }
                    });
                }
            }).catch((err) => {
                dispatch({
                    type: SAVE_GLOBAL_AP_SETTING_FAIL,
                    params: {
                        errMsg: err
                    }
                });
            });
        }
    })


    // let triggerPost = new Promise((resolve, reject) => {
    //     triggerDeviceInfo(resolve, reject, token, settingsObj.site)
    // })
    // triggerPost
    // .then((triggerRes) => {
    //     if ('success' === triggerRes.responseMsg) {
    //         let value = convertBandwidth(settingsObj, true);
    //         let doPost = new Promise((resolve, reject) => {
    //             saveGlobalApSettings(resolve, reject, token, value);
    //         })
    //         doPost
    //         .then((data) => {
    //             if ('success' === data.responseMsg) {
    //                 let value = convertBandwidth(data.globalApSetting, false);
    //                 dispatch({
    //                     type: SAVE_GLOBAL_AP_SETTING_SUCCESS,
    //                     params: {
    //                         globalApInfo: value
    //                     }
    //                 });
    //             } else {
    //                 dispatch({
    //                     type: SAVE_GLOBAL_AP_SETTING_FAIL,
    //                     params: {
    //                         errMsg: data.responseMsg
    //                     }
    //                 });
    //             }
    //         }).catch((err) => {
    //             dispatch({
    //                 type: SAVE_GLOBAL_AP_SETTING_FAIL,
    //                 params: {
    //                     errMsg: err
    //                 }
    //             });
    //         });
    //     }
    // })   
    
    dispatch({
        type: SAVE_GLOBAL_AP_SETTING
    });

}

export const selectNetworkZoneDetail = (detailData) => (dispatch) => {
    dispatch({
        type : SELECT_NETWORK_ZONE_DETAIL,
        params: {
            networkZoneDetail: detailData
        }
    });
}

export const doSaveNetworkZone = (token, reqBodyObj) => (dispatch) => {
    if (reqBodyObj) {
        let doPost = new Promise((resolve, reject) => {
            saveNetworkZone(resolve, reject, token, reqBodyObj);
        });
    
        doPost
        .then((data) => {
            console.log(data);
            if ('success' === data.responseMsg && !data.errMsg) {
                dispatch({
                    type: SAVE_NETWORK_ZONE_DATA_SUCCESS
                });
            }else if('F0002' === data.status){
                dispatch({
                    type: SAVE_NETWORK_ZONE_IMPORT_FILE_FAIL,
                    params: {
                        errMsg: data.errMsg
                    }
                });
            } else {
                dispatch({
                    type: SAVE_NETWORK_ZONE_DATA_FAIL,
                    params: {
                        errMsg: data.errMsg
                    }
                });
            }
        }).catch((err) => {            
            dispatch({
                type: SAVE_NETWORK_ZONE_DATA_FAIL,
                params: {
                    errMsg: err
                }
            });
        });
    }

    dispatch({
        type: SAVE_NETWORK_ZONE_DATA        
    });
}

export const doRemoveNetworkZone = (token, networkZoneSeq, siteId) => (dispatch) => {
    if (networkZoneSeq) {
        let doPost = new Promise((resolve, reject) => {
            removeNetworkZone(resolve, reject, token, networkZoneSeq, siteId);
        });
    
        doPost
        .then((data) => {
            if ('success' === data.responseMsg && !data.errMsg) {
                dispatch({
                    type: DELETE_NETWORK_ZONE_SUCCESS
                });
            } else {
                dispatch({
                    type: DELETE_NETWORK_ZONE_FAIL,
                    params: {
                        errMsg: data.errMsg
                    }
                });
            }
        }).catch((err) => {            
            dispatch({
                type: DELETE_NETWORK_ZONE_FAIL,
                params: {
                    errMsg: err
                }
            });
        });
    }

    dispatch({
        type: DELETE_NETWORK_ZONE        
    });
}

export const getGroupAPSettingsDetailDataAction = (detailData) => (dispatch) => {
    dispatch({
        type : GET_GROUP_AP_SETTINGS_DETAIL_SUCCESS,
        params: {
            groupSettingsDetail: detailData
        }
    });
}

export const doDeleteGroupAPSettingsData = (id, authToken) => (dispatch) => {
    let doPost = new Promise((resolve, reject) => {
        deleteGroupAPSettingsData(resolve, reject, id, authToken);
    });
    doPost
    .then((data)=>{
        if ('success' === data.status) {
            dispatch({
                type: DELETE_GROUP_AP_SETTINGS_DATA_SUCCESS
            });
        } else {
            dispatch({
                type: DELETE_GROUP_AP_SETTINGS_DATA_FAIL,
                params: {
                    errMsg: data.status
                }
            });
        }
    }).catch((err)=>{
        dispatch({
            type: DELETE_GROUP_AP_SETTINGS_DATA_FAIL,
            params: {
                errMsg: err
            }
        });
    })
    dispatch({
        type: DELETE_GROUP_AP_SETTINGS_DATA
    });
}


export const getApExclusionSettingsDetailDataAction = (detailData) => (dispatch) => {
    dispatch({
        type : GET_AP_EXCLUSION_SETTINGS_DETAIL_SUCCESS,
        params: {
            apExclusionsData: detailData
        }
    });
}

export const doSaveApExlusionData = (token, deviceList, site) => (dispatch) => {
    let doPost = new Promise((resolve, reject) => {
        saveApExlusionData(resolve, reject, token, deviceList, site);
    });
    doPost
    .then((data)=>{
        if ('success' === data.responseMsg) {
            dispatch({
                type: SAVE_AP_EXCLUSION_DATA_SUCCESS
            });
        } else {
            dispatch({
                type: SAVE_AP_EXCLUSION_DATA_FAIL,
            });
        }
    }).catch((err)=>{
        dispatch({
            type: SAVE_AP_EXCLUSION_DATA_FAIL,
            params: {
                errMsg: err
            }
        });
    })
    dispatch({
        type : SAVE_AP_EXCLUSION_DATA,
    });
}


export const getWiFiSettingsDetailDataAction = (detailData) => (dispatch) => {
    dispatch({
        type : GET_WIFI_SETTINGS_DETAIL_SUCCESS,
        params: {
            wifiSettingsDetail: detailData
        }
    });
}

export const saveWiFiSettingsDetailDataAction = (info, confirm) => (dispatch) => {
    dispatch({
        type : SAVE_WIFI_SETTINGS_DETAIL_DATA,
        params: {
            info: info,
            confirm: confirm
        }
    });
}

export const doSaveWiFiSettingsData = (token, reqObj) => (dispatch) => {

    let doPost = new Promise((resolve, reject) => {
        saveWiFiSettingsData(resolve, reject, token, reqObj);
    });
    doPost
    .then((data)=>{
        if ('success' === data.responseMsg) {
            dispatch({
                type: SAVE_WIFI_SETTINGS_DATA_SUCCESS
            });
        } else {
            dispatch({
                type: SAVE_WIFI_SETTINGS_DATA_FAIL,
                params: {
                    errMsg: data.responseMsg? data.responseMsg:data.errMsg + '\r\n' + (data.details ?? '')
                }
            });
        }
    }).catch((err)=>{
        dispatch({
            type: SAVE_WIFI_SETTINGS_DATA_FAIL,
            params: {
                errMsg: err
            }
        });
    })
    dispatch({
        type : SAVE_WIFI_SETTINGS_DATA,
    });
}
export const doDeleteWiFiSettingsDetail = (id, authToken) => (dispatch) => {
    let doPost = new Promise((resolve, reject) => {
        deleteWiFiSettingsData(resolve, reject, id, authToken);
    });
    doPost
    .then((data)=>{
        if ('success' === data.status) {
            dispatch({
                type: DELETE_WIFI_SETTINGS_SUCCESS
            });
        } else {
            dispatch({
                type: DELETE_WIFI_SETTINGS_FAIL,
                params: {
                    errMsg: data.status
                }
            });
        }
    }).catch((err)=>{
        dispatch({
            type: DELETE_WIFI_SETTINGS_FAIL,
            params: {
                errMsg: err
            }
        });
    })
    dispatch({
        type: DELETE_WIFI_SETTINGS
    });
}

export const doSetWifiList = (settingsWifiList) => (dispatch) => {
    dispatch({
        type : SET_WIFI_LIST,
        params: {
            settingsWifiList: settingsWifiList
        }
    });
}

export const verifyRemoveWifi = (wifiId) => {

}

// export const doGetMacWhiteList = (token) => (dispatch) => {
//     let doPost = new Promise((resolve, reject) => {
//         getMacWhiteList(resolve, reject, token);
//     });

//     doPost
//     .then((response) => {
//         if ('success' === response.responseMsg) {
//             dispatch({
//                 type: GET_DEVICE_MAC_WHITE_LIST_SUCCESS,
//                 params: {
//                     macWhiteList: response.data
//                 }
//             });
//         } else {
//             dispatch({
//                 type: GET_DEVICE_MAC_WHITE_LIST_FAIL,
//                 params: {
//                     errMsg: response.responseMsg
//                 }
//             });
//         }            
//     }).catch((err) => {
//         dispatch({
//             type: GET_DEVICE_MAC_WHITE_LIST_FAIL,
//             params: {
//                 errMsg: err
//             }
//         });
//     });

//     dispatch({
//         type : GET_DEVICE_MAC_WHITE_LIST
//     });
// }

// export const doUpdateMacWhiteList = (token, ids) => (dispatch) => {
//     let doPost = new Promise((resolve, reject) => {
//         updateMacWhiteList(resolve, reject, token, ids);
//     });

//     doPost
//     .then((response) => {
//         if ('success' === response.responseMsg) {
//             dispatch({
//                 type: UPDATE_DEVICE_MAC_WHITE_LIST_SUCCESS,
//                 params: {
//                     macWhiteList: response.data
//                 }
//             });
//         } else {
//             dispatch({
//                 type: UPDATE_DEVICE_MAC_WHITE_LIST_FAIL,
//                 params: {
//                     errMsg: response.responseMsg
//                 }
//             });
//         }            
//     }).catch((err) => {
//         dispatch({
//             type: UPDATE_DEVICE_MAC_WHITE_LIST_FAIL,
//             params: {
//                 errMsg: err
//             }
//         });
//     });

//     dispatch({
//         type : UPDATE_DEVICE_MAC_WHITE_LIST
//     });
// }


export const doGetGroupDevice = (token, siteId) => (dispatch) => {
    let doPost = new Promise((resolve, reject) => {
        getGroupDevice(resolve, reject, token, siteId);
    })

    doPost
    .then((data) => {
        if ('success' === data.responseMsg) {
            dispatch({
                type: GET_GROUP_DEVICES_SUCCESS,
                params: {
                    groupDevices: data.groupDevices
                }
            });
        } else {
            dispatch({
                type: GET_GROUP_DEVICES_FAIL,
                params: {
                    errMsg: data.responseMsg
                }
            });
        }
    }).catch((err) => {
        dispatch({
            type: GET_GROUP_DEVICES_FAIL,
            params: {
                errMsg: err
            }
        });
    });

    dispatch({
        type: GET_GROUP_DEVICES
    });
}

export const doSyncWifiSetting = (token, siteId) => (dispatch) => {
    let doPost = new Promise((resolve, reject) => {
        syncWifiSetting(resolve, reject, token, siteId);
    });

    doPost
    .then((data) => {
        if ('success' === data.responseMsg) {
            dispatch({
                type: SYNC_WIFI_SETTING_SUCCESS
            });
        } else {
            dispatch({
                type: SYNC_WIFI_SETTING_FAIL,
                params: {
                    errMsg: data.responseMsg
                }
            });
        }
    }).catch((err) => {
        dispatch({
            type: SYNC_WIFI_SETTING_FAIL,
            params: {
                errMsg: err
            }
        });
    });

    dispatch({
        type: SYNC_WIFI_SETTING
    });
}

export const getGuestPortakSettingsDetailDataAction = (detailData) => (dispatch) => {
    dispatch({
        type : GET_GUEST_PORTAL_SETTINGS_DETAIL_SUCCESS,
        params: {
            guestPortalSettingsDetail: detailData
        }
    });
}

export const doDeleteGuestPortalSettingsDetail = (id, authToken) => (dispatch) => {
    let doPost = new Promise((resolve, reject) => {
        deleteGuestPortalSettingsData(resolve, reject, id, authToken);
    });
    doPost
    .then((data)=>{
        if ('success' === data.status) {
            dispatch({
                type: DELETE_GUEST_PORTAL_SETTINGS_SUCCESS
            });
        } else {
            dispatch({
                type: DELETE_GUEST_PORTAL_SETTINGS_FAIL,
                params: {
                    errMsg: data.status
                }
            });
        }
    }).catch((err)=>{
        dispatch({
            type: DELETE_GUEST_PORTAL_SETTINGS_FAIL,
            params: {
                errMsg: err
            }
        });
    })
    dispatch({
        type: DELETE_GUEST_PORTAL_SETTINGS
    });
}

export const doLocalSoftwareUpdate = (formData, token) => (dispatch) => {
    let doPost = new Promise((resolve, reject) => {
        localSoftwareUpdate(resolve, reject, token, formData);
    });
    doPost
    .then((res) => {        
        let dispatchType = '';
        if ('success' === res.responseMsg) {
            dispatchType = PRISMX_LOCAL_UPGRADE_SUCCESS;
        } else {
            dispatchType = PRISMX_LOCAL_UPGRADE_FAIL;
        }
        dispatch({
            type: dispatchType
        });      
    }).catch((err) => {
        dispatch({
            type: PRISMX_LOCAL_UPGRADE_FAIL
        });
    });

    dispatch({
        type : PRISMX_LOCAL_UPGRADE_INIT
    });
}